import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { ForSigningHttpService } from '../services/forsigning/forsigning.http.service';
import { DashboardHttpUtil } from '../components/dashboard/dashboard.util';
import { StorageUtil } from '../utils/storage.util';

@Injectable()
export class ForSigningResolver implements Resolve<any> {

  model: any = {
    data: ''
  };

  constructor(private contractHttpService: ForSigningHttpService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // TODO: get data from contract model service or even child need resolver?
    let id = +route.paramMap.get('id');
    let requestParams = DashboardHttpUtil.prepareTokenParam(StorageUtil.getToken());
    return this.contractHttpService.getSingleContract(id, requestParams);
  }
}



// WEBPACK FOOTER //
// ./src/app/resolves/forsigning.resolver.ts